module.exports = __webpack_public_path__ + "static/img/banner.f62a6cbc.jpg";